import { Breadcrumbs, Link } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { galleryActions } from "../actions";
import Sites from "../helpers/sitesLinks";

const stylesCatalogo = {
  breadCrumb: {
    fontSize: "15px",
    marginBottom: "5px",
    '@media (max-width: 600px)': {
      fontSize: '12.5px',
    }
  },
  prodDetails: {
    fontSize: "15px",
    '@media (max-width: 600px)': {
      fontSize: '12.5px',
      marginTop: "5px"
    }
  },
  link: {
    fontSize: "15px",
    cursor: "pointer",
    '@media (max-width: 600px)': {
      fontSize: '13.5px'
    }
  },
};

const Breadcrumb = ({ prodCategoria, prodRubro, prodSubRubro }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { categoria, rubro, subRubro, promocion } = useSelector(
    (state) => state.gallery
  );
  const matchRouteWithParams = (path, route) => {
    if (route !== "/catalogo-details/:productId") {
      return path === route
    }
    const regex = new RegExp(route.replace(":productId", "[^/]+"));
    return regex.test(path);
  };


  const site = Sites.urls.some(route => matchRouteWithParams(location.pathname, route))
    ? "/catalogo"
    : "/products";

  let styles = stylesCatalogo;

  const setCategoria = (categoria = "", rubro = "", subRubro = "", promocion = "") => {
    dispatch(galleryActions.setSearchTerm(""))
    dispatch(
      galleryActions.setCategoria(categoria === "Todas" ? "" : categoria)
    );
    dispatch(galleryActions.setRubro(rubro));
    dispatch(galleryActions.setSubRubro(subRubro));
    dispatch(galleryActions.setPromocion(promocion));

    if (location.pathname !== site) navigate(site);
  };

  return (
    <Breadcrumbs
      // separator={site === "/catalogo" ? "›" : "/"}
      separator={"›"}
      aria-label="breadcrumb"
      sx={prodCategoria ? styles.prodDetails : styles.breadCrumb}
    >
      {prodCategoria && (
        <Link
          underline="hover"
          color="inherit"
          onClick={() => setCategoria("Todas")}
          sx={styles.link}
        >
          Inicio
        </Link>
      )}
      {(categoria || prodCategoria) && (
        <Link
          underline="hover"
          color="inherit"
          onClick={() => {
            prodCategoria
              ? setCategoria(prodCategoria, "", "")
              : setCategoria(categoria, "", "");
          }}
          sx={styles.link}
        >
          {prodCategoria || categoria}
        </Link>
      )}
      {(rubro || prodRubro) && (
        <Link
          underline="hover"
          color="inherit"
          onClick={() => {
            prodCategoria && prodRubro
              ? setCategoria(prodCategoria, prodRubro, "")
              : setCategoria(categoria, rubro, "");
          }}
          sx={styles.link}
        >
          {prodRubro || rubro}
        </Link>
      )}
      {(subRubro || prodSubRubro) && (
        <Link
          underline="hover"
          color="text.primary"
          sx={styles.link}
          onClick={() => {
            prodCategoria && prodRubro && prodSubRubro
              ? setCategoria(prodCategoria, prodRubro, prodSubRubro)
              : setCategoria(categoria, rubro, subRubro);
          }}
        >
          {prodSubRubro || subRubro}
        </Link>
      )}
      {promocion && (
        <Link
          underline="hover"
          color="text.secondary"
          sx={styles.link}
          onClick={() => {
            setCategoria("", "", "", promocion);
          }}
        >
          {promocion === "Lanzamient" ? "Lanzamientos" : promocion}
        </Link>
      )}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
